import React from "react";

// Top-of-tab notice for settings a template left empty that its type has defaults for. The tab
// fills them in as unsaved changes; this says what came in and what Save does.
type Props = {
    items: string[];
};

const INFO_TEXT = "#1f4e79";

export default function DefaultsAddedNotice({ items }: Props) {
    if (items.length === 0) return null;

    return (
        <div
            role="status"
            data-testid="defaults-added-notice"
            style={{
                display: "flex",
                gap: "10px",
                padding: "10px 14px",
                marginBottom: "16px",
                backgroundColor: "#eaf4fc",
                border: "1px solid #b6d6f0",
                borderRadius: "6px",
                color: INFO_TEXT,
                fontSize: "13px",
            }}
        >
            <i className="dx-icon-info" style={{ fontSize: "18px", lineHeight: "20px", color: "#2f7bbf" }} aria-hidden="true" />
            <div>
                <div style={{ fontWeight: 600, marginBottom: "2px" }}>Settings Defaults</div>
                <div>
                    Some default settings are missing or have been added since this template was created. You may
                    save to keep them or discard to leave the template as is. Here's a summary of what would be saved:
                </div>
                <ul style={{ margin: "6px 0 0", paddingLeft: "18px" }}>
                    {items.map(item => <li key={item}>{item}</li>)}
                </ul>
            </div>
        </div>
    );
}

// Marks a single field the notice is talking about.
export function DefaultTag() {
    return (
        <span
            style={{
                marginLeft: "6px",
                padding: "0 6px",
                borderRadius: "8px",
                backgroundColor: "#eaf4fc",
                border: "1px solid #b6d6f0",
                color: INFO_TEXT,
                fontSize: "10px",
                fontWeight: 600,
                whiteSpace: "nowrap",
            }}
        >
            Default
        </span>
    );
}
